// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1rLR0LUzbFY0a8Wh2FnlLe {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 0.857rem;\n  margin: 0;\n}\n._2VrEFtECQ1txCjank4exlS {\n  display: inline-flex;\n  align-items: center;\n}\n._2VrEFtECQ1txCjank4exlS:not(:last-child) {\n  padding-right: 0.75rem;\n}\n._2VrEFtECQ1txCjank4exlS ._1_KQuL0qGKnGkSWYwDices {\n  color: #787878;\n}\n._2VrEFtECQ1txCjank4exlS ._1_KQuL0qGKnGkSWYwDices:after {\n  content: ':';\n}\n.Ae7yGtacjWki8_BlY0-Ku {\n  margin-left: 0.5rem;\n}\n._2x3yp5O6-Fiz4_rvSluTBf {\n  color: #787878;\n  font-style: italic;\n}\n._2x3yp5O6-Fiz4_rvSluTBf:before {\n  content: '<';\n}\n._2x3yp5O6-Fiz4_rvSluTBf:after {\n  content: '>';\n}\n", ""]);
// Exports
exports.locals = {
	"description-list": "_1rLR0LUzbFY0a8Wh2FnlLe",
	"descriptionList": "_1rLR0LUzbFY0a8Wh2FnlLe",
	"container": "_2VrEFtECQ1txCjank4exlS",
	"term": "_1_KQuL0qGKnGkSWYwDices",
	"value": "Ae7yGtacjWki8_BlY0-Ku",
	"empty-byte": "_2x3yp5O6-Fiz4_rvSluTBf",
	"emptyByte": "_2x3yp5O6-Fiz4_rvSluTBf"
};
module.exports = exports;
